import {AfterViewInit, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {LeaveOfAbsence} from "../../../../shared/interface/employee";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {RegionalService} from "../../../../shared/services/regional.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {AuthService} from "../../../../shared/services/auth.service";
import {first, takeUntil} from "rxjs/operators";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  DictService, LEAVE_APPLICATION_TIME_FIRST, LEAVE_APPLICATION_TIME_SECOND,
  LEAVE_APPLICATION_TYPE_CHILDCARE_LEAVE,
  LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE,
  LEAVE_APPLICATION_TYPE_ON_DEMAND_LEAVE, LEAVE_APPLICATION_TYPE_RECEPTION,
  LEAVE_APPLICATION_TYPE_RECREATIONAL_LEAVE,
  WORKING_HOURS_3_4, WORKING_HOURS_7_16, WORKING_HOURS_7_8,
} from "../../../../shared/services/dict.service";
import {EmployeeService} from "../../../../shared/services/employee.service";
import {Dictionary} from "../../../../shared/interface/dictionary";
import {FileBase64} from "../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component";

export interface LeaveApplicationAddDialogData {
  leaveOfAbsence?: LeaveOfAbsence;
  workingHours?: Dictionary;
}


@Component({
  selector: 'app-leave-application-add-dialog',
  templateUrl: './leave-application-add-dialog.component.html',
  styleUrls: ['./leave-application-add-dialog.component.scss']
})
export class LeaveApplicationAddDialogComponent implements OnInit,  OnDestroy  {
  holidays = [
    "2026-01-01",
    "2026-01-06",
    "2026-04-05",
    "2026-04-06",
    "2026-05-01",
    "2026-05-03",
    "2026-05-24",
    "2026-06-04",
    "2026-08-15",
    "2026-11-01",
    "2026-11-11",
    "2026-12-24",
    "2026-12-25",
    "2026-12-26",
  ];

  // wmymiar godziń dla 1/1 | 7/8 | 1/2 |3/4 etatu
  hourDimensionsv1 = [
    { value: '60', label: '1h' },
  ];
  // wmymiar godziń dla 7/8 etatu
  hourDimensionsv2 = [
    { value: '60', label: '1h' },
    { value: '90', label: '1,5 h ' },
  ];
  // wmymiar godziń dla 7/16 etatu
  hourDimensionsv3 = [
    { value: '60', label: '1h' },
    { value: '45', label: '45min' },
  ];

  readonly LEAVE_TYPES = [
    LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE,
    LEAVE_APPLICATION_TYPE_CHILDCARE_LEAVE,
    LEAVE_APPLICATION_TYPE_ON_DEMAND_LEAVE,
    LEAVE_APPLICATION_TYPE_RECREATIONAL_LEAVE
  ];

  readonly LEAVE_TIME = [
    LEAVE_APPLICATION_TIME_FIRST,
    LEAVE_APPLICATION_TIME_SECOND
  ];


  leaveApplicationForm: FormGroup;
  formErrors: any = {};
  processingRequest = false;
  userPermissions: ReplaySubject<UserPermissions>;
  leaveOfAbsenceControl: FormControl;
  fileContentControl: FormControl;
  fileNameControl: FormControl;
  typeControl: FormControl;
  timeControl: FormControl;
  dayControl: FormControl;
  noteControl: FormControl;
  halfTmeControl: FormControl;
  startControl: FormControl;
  endControl: FormControl;
  leaveTypeControl: FormControl;
  startsAtTimeControl: FormControl;
  endAtTimeControl: FormControl;
  hourDimensionsControl: FormControl;
  leaveApplicationFormValid = false;
  leaveOfAbsence: LeaveOfAbsence;
  workingHours: Dictionary;
  half: boolean = false;
  hour: boolean = false;
  noteValid: boolean = false;
  recreational: boolean = false;
  reception: boolean = false;
  livaApplicationTime: string [] = [];
  hourDimensions: any[] = [];
  fileMaxSize = 5242880;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private leaveType: any;

  constructor(
    private regionalService: RegionalService,
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private auth: AuthService,
    private dictService: DictService,
    @Inject(MAT_DIALOG_DATA) public data: LeaveApplicationAddDialogData,
    public dialogRef: MatDialogRef<LeaveApplicationAddDialogComponent>,
    private employeeService: EmployeeService
) {
    this.leaveOfAbsence = data.leaveOfAbsence;
    this.workingHours = data.workingHours;
    this.userPermissions = this.auth.getUserPermissions();
    this.leaveApplicationForm = this.fb.group({
      leaveOfAbsence: this.leaveOfAbsenceControl = fb.control(this.leaveOfAbsence.uuid, ),
      type: this.typeControl = fb.control(''),
      time: this.timeControl = fb.control(null),
      day: this.dayControl = fb.control(1),
      note: this.noteControl = this.fb.control(''),
      halfTme: this.halfTmeControl = this.fb.control(false),
      start: this.startControl = fb.control(''),
      end: this.endControl = fb.control(''),
      half: this.leaveTypeControl = this.fb.control('full'),
      hourDimension: this.hourDimensionsControl = fb.control(''),
      fileContent: this.fileContentControl = fb.control(''),
      fileName: this.fileNameControl = fb.control(''),
      startAt: this.startsAtTimeControl = fb.control('09:00', [Validators.required]),
      endAt: this.endAtTimeControl = fb.control('10:00', [Validators.required]),
    });
  }


  ngOnInit(): void {
    this.leaveApplicationForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
          this.leaveApplicationFormValid = this.leaveApplicationForm.valid;
        }
      );

    this.typeControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
            this.dictService.getKey(dictId)
              .subscribe((dictKey: string) => {
                if (dictKey === LEAVE_APPLICATION_TYPE_OCCASIONAL_LEAVE){
                  this.noteValid = true;
                }else {
                  this.noteValid = false;
                }

                if (dictKey === LEAVE_APPLICATION_TYPE_RECREATIONAL_LEAVE || dictKey === LEAVE_APPLICATION_TYPE_CHILDCARE_LEAVE) {
                  this.leaveTypeControl.enable();
                } else {
                  this.leaveTypeControl.setValue('full');
                  this.onSelectionChange('full');
                  this.leaveTypeControl.disable();
                }

                if (dictKey === LEAVE_APPLICATION_TYPE_RECREATIONAL_LEAVE) {
                  this.recreational = true;
                } else {
                  this.recreational = false;
                  this.leaveTypeControl.setValue('full');
                  this.onSelectionChange('full');
                }

                if (dictKey === LEAVE_APPLICATION_TYPE_RECEPTION) {
                  this.reception = true;
                  this.endControl.setValue(this.startControl.value);
                  this.endControl.disable();
                } else {
                  this.reception = false;
                }

              });
          });

    this.startControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: any) => {
        if (this.half || this.reception){
          this.endControl.setValue(val);
        }
        this.updateLeaveDays();
      });

    this.endControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: any) => {
        this.updateLeaveDays();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    if (this.processingRequest ){
      return;
    }
    if (!this.leaveApplicationForm.valid) {
      this.leaveApplicationForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.processingRequest = true;
    this.employeeService.sendFormAplication(this.leaveApplicationForm.getRawValue()
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open( 'Pomyślnie utworzono wniosek', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.leaveApplicationForm, this.formErrors);
          this.snack.open(error.error.error.text, error.status.toString(), {
            duration: 4000,
          });
        }
        this.processingRequest = false;

      });
  }

  cancel(): void {
    this.dialogRef.close();
  }


  onSelectionChange(value: string) {
    if (value !== 'full') {
      this.timeControl.reset();
      this.half = true;
      this.endControl.setValue(this.startControl.value);
      this.endControl.disable();
      this.timeControl.enable();
      if (value === 'hour') {
        this.hour = true;
        this.hourDimensionsControl.enable();
      }else {
        this.hour = false;
        this.hourDimensionsControl.disable();
      }
        if (this.workingHours.key === WORKING_HOURS_7_16){
          this.hourDimensions = this.hourDimensionsv3;
        } else if  (this.workingHours.key === WORKING_HOURS_7_8)
        {
          this.hourDimensions = this.hourDimensionsv2;
        }else {
          this.hourDimensions = this.hourDimensionsv1;
        }

    }else {
      this.half = false;
      this.hour = false;
      this.timeControl.disable();
      this.hourDimensionsControl.disable();

      this.endControl.enable();
    }
  }

  fileSelected($event: FileBase64): void {
    this.fileNameControl.setValue($event?.filename);
    this.fileContentControl.setValue($event?.base64);
  }

  countLeaveDays(start: Date | string, end: Date | string,  holidays: Set<string>): number {
    if (!start || !end) {
        return 0;
    }

    const startDate = new Date(start);
    const endDate = new Date(end);

    if (startDate > endDate) {
        return 0;
    }

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    let days = 0;
    const current = new Date(startDate);

    while (current <= endDate) {
      const day = current.getDay(); // 0 = niedziela, 6 = sobota

      const dateStr =
        current.getFullYear() +
        "-" +
        String(current.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(current.getDate()).padStart(2, "0");

      const isWeekend = day === 0 || day === 6;
      const isHoliday = holidays.has(dateStr);

      if (!isWeekend && !isHoliday) {
        days++;
      }

      current.setDate(current.getDate() + 1);
    }

    return days;
  }

  updateLeaveDays(): void {
    this.dayControl.setValue( this.countLeaveDays(
      this.startControl.value,
      this.endControl.value,
      new Set(this.holidays)
    ));
  }
}
